import MarkdownContent from './Helpers/MarkdownContent'

const MarkdownPage = (props) => (
  <MarkdownContent
    overrideProps={{
      h1: { variant: 'h3', gutterBottom: true },
      h2: { variant: 'h4', gutterBottom: true, mt: 3 },
      h3: { variant: 'h5', gutterBottom: true, mt: 2 },
      h4: { variant: 'h6', gutterBottom: true, mt: 1 },
      p: { gutterBottom: true },
    }}
    {...props}
  />
)

export default MarkdownPage
